<template>
  <div
    v-click-outside="closeTravllerList"
    class="booking__input"
    :class="{ 'is-open': showList }"
  >
    <label class="booking__input-label">مسافران و اتاق</label>
    <div class="booking__input-inner" @click="showTravellerList">
      <div class="booking__travellers-btn">
        <span v-if="adultsCount" class="booking__travellers-btn-item">
          <span>{{ adultsCount }}</span>
          بزرگسال
        </span>

        <span v-if="childsCount" class="booking__travellers-btn-item">
          <span>{{ childsCount }}</span>
          کودک
        </span>

        <span v-if="roomsCount" class="booking__travellers-btn-item">
          <span>{{ roomsCount }}</span>
          اتاق
        </span>
      </div>
    </div>

    <div class="booking__travellers-list" :class="{ 'is-show': showList }">
      <div class="booking__item-header hide-in-desktop">
        <span>مسافران و اتاق</span>
        <button @click="closeTravllerList">
          <i class="icon-close" />
        </button>
      </div>

      <div class="booking__travellers-items">
        <div class="booking__rooms">
          <div v-for="room in rooms" :key="room.key" class="booking__room">
            <div class="booking__room-title">
              <span class="bold">اتاق {{ rooms.indexOf(room) + 1 }}</span>

              <button v-if="rooms.length > 1" @click="roomDelete(room)">
                <i class="icon-close-circle js-room-delete" />
              </button>
            </div>

            <ul class="booking__passengers">
              <li class="booking__passenger">
                <div class="booking__passenger-right">
                  <span>بزرگسال</span>
                  <label>12 سال به بالا</label>
                </div>

                <div class="booking__passenger-left">
                  <div class="counter">
                    <button
                      class="counter-button"
                      @click="addAdult(rooms.indexOf(room))"
                    >
                      <i class="icon-add"></i>
                    </button>
                    <span>{{ room.adults }}</span>
                    <button
                      class="counter-button"
                      @click="lowOffAdult(rooms.indexOf(room))"
                    >
                      <i class="icon-minus"></i>
                    </button>
                  </div>
                </div>
              </li>

              <li class="booking__passenger">
                <div class="booking__passenger-right">
                  <span>کودک</span>
                </div>

                <div class="booking__passenger-left">
                  <div class="counter">
                    <button
                      class="counter-button"
                      @click="addChild(rooms.indexOf(room))"
                    >
                      <i class="icon-add"></i>
                    </button>
                    <span>{{ room.childs.length }}</span>
                    <button
                      class="counter-button"
                      @click="lowOffChild(rooms.indexOf(room))"
                    >
                      <i class="icon-minus"></i>
                    </button>
                  </div>
                </div>
              </li>

              <li
                class="booking__passenger"
                v-for="(child, index) in room.childs"
                :key="index"
              >
                <div class="booking__passenger-right">
                  <span>سن کودک {{ room.childs.indexOf(child) + 1 }}</span>
                </div>

                <div
                  class="booking__passenger-left booking__passenger--number-of-children"
                >
                  <select
                    v-model="
                      rooms[rooms.indexOf(room)].childs[
                        room.childs.indexOf(child)
                      ]
                    "
                  >
                    <option
                      v-for="childAge in childAges"
                      :key="childAge.value"
                      :value="childAge.value"
                    >
                      {{ childAge.title }}
                    </option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="booking__passenger-add-room">
          <button
            class="btn btn--icon w-100"
            title="افزودن اتاق"
            @click="addRoom"
            :disabled="rooms.length >= 4"
          >
            <i class="icon-add ml--1"></i>
            <span>افزودن اتاق</span>
          </button>
        </div>

        <span class="booking__validation" v-if="error.length">{{ error }}</span>
      </div>

      <div class="booking__confirm hide-in-desktop">
        <button class="btn btn--primary" @click="closeTravllerList">
          تایید
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { childAges } from "../../../../ConstantData/constants";
import { clickOutside } from "../../../../Helpers/directives";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  name: "Travellers",

  data() {
    return {
      showList: false,

      error: "",

      rooms: [
        {
          adults: 2,
          childs: [],
          key: uuidv4(),
        },
      ],

      childAges: [...childAges],
    };
  },

  computed: {
    // return rooms count
    roomsCount() {
      return this.rooms.length;
    },

    //return adults count
    adultsCount() {
      let adults = 0;

      this.rooms.forEach((room) => {
        adults += room.adults;
      });

      return adults;
    },

    // return childs count
    childsCount() {
      let childs = 0;

      this.rooms.forEach((room) => {
        childs += room.childs.length;
      });

      return childs;
    },
  },

  methods: {
    // show rooms and travellers list
    showTravellerList() {
      this.$emit("scroll-to-booking-section", this.$el);

      if (this.showList) {
        this.showList = false;
      } else {
        if (window.innerWidth < 993) {
          root.classList.add("no-scroll");
        }

        this.showList = true;
      }
    },

    // add room to list
    addRoom() {
      if (this.roomsCount < 4) {
        this.rooms.push({
          adults: 1,
          childs: [],
          key: uuidv4(),
        });
      }
    },

    // remove room from list
    roomDelete(room) {
      this.rooms.splice(this.rooms.indexOf(room), 1);
    },

    // add adult to room
    addAdult(roomIndex) {
      if (this.rooms[roomIndex].adults < 6) {
        this.rooms[roomIndex].adults++;
      }
    },

    // low off adult from room
    lowOffAdult(roomIndex) {
      if (this.rooms[roomIndex].adults > 1) {
        this.rooms[roomIndex].adults--;
      }
    },

    // add child to room
    addChild(roomIndex) {
      if (this.rooms[roomIndex].childs.length < 4) {
        this.rooms[roomIndex].childs.push(0);
      }
    },

    // low off child from room
    lowOffChild(roomIndex) {
      this.rooms[roomIndex].childs.pop();
    },

    // close travller list
    closeTravllerList(e) {
      if (this.showList && !e.target.classList.contains("js-room-delete")) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        this.$emit("remove-search-holder-z-index");
      }
    },
  },

  mounted() {
    const roomsOccupancies =
      window.searchInitialize && window.searchInitialize.search
        ? window.searchInitialize.search.occupancies
        : [];

    if (roomsOccupancies.length > 0) {
      this.rooms = [];

      roomsOccupancies.forEach((room) => {
        this.rooms.push({
          adults: room.adult,
          childs: room.ages,
          key: uuidv4(),
        });
      });
    }
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>
